import emptyCadastroBase from './emptyCadastroBase'

export default {
  ...emptyCadastroBase,
  tipo: {
    codigo: 'TRANSFERENCIA_DIREITOS'
  },
  json: {
    cadastrante: {
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      }
    },
    interessado: {
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      },
      conjuge: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      },
      documentos: [],
      espolio: null
    },
    imovel: {
      id: null,
      documentos: [],
      denominacao: null,
      area: 0,
      nomeColonia: null,
      localizacao: null,
      municipio: null,
      // matricula
      cnsMatricula: null,
      numeroMatricula: null,
      livroMatricula: null,
      numeroFolhaMatricula: null,
      // dados do titulo
      nomeBeneficiarioTitulo: null
    },
    georreferenciamento: {
      localizacoes: [],
      documentos: [],
      denominacao: '',
      possuiGeorreferenciamento: '',
      responsavel: {
        nome: '',
        codigoIncra: '',
        creaRnp: '',
        formacao: '',
        codigoCredenciamento: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/para/empty/emptyTransferenciaDireito.js